// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/component/element/date-picker.css
// module id = 2001
// module chunks = 0